import { render, staticRenderFns } from "./CadFrentista.vue?vue&type=template&id=75dc2205&"
import script from "./CadFrentista.vue?vue&type=script&lang=js&"
export * from "./CadFrentista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports